import React from 'react';
import { FaStar, FaBolt, FaHandshake, FaLightbulb, FaRocket, FaLeaf, FaHeart, FaUsers } from 'react-icons/fa';

const values = [
  { icon: <FaStar />, name: 'Innovative Synergy' },
  { icon: <FaBolt />, name: 'Client-Centric Excellence' },
  { icon: <FaHandshake />, name: 'Integrity & Transparency' },
  { icon: <FaLightbulb />, name: 'Adaptive Agility' },
  { icon: <FaRocket />, name: 'Sustainable Impact' },
  { icon: <FaLeaf />, name: 'Holistic Approach' },
  { icon: <FaHeart />, name: 'Collaborative Empowerment' },
  { icon: <FaUsers />, name: 'Excellence Through Diversity' },
];

const Values = () => {
  return (
    <section className="py-16 bg-gradient-to-r from-blue-50 via-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6 text-center">
     
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12">
          {values.map((value, index) => (
            <div
              key={index}
              className="group relative flex flex-col items-center text-center p-8 bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 ease-in-out transform hover:-translate-y-3"
            >
              {/* Icon with hover effect */}
              <div className="text-6xl mb-6 text-[#13689b] hover:text-white transition-all duration-300">
                {value.icon}
              </div>
              {/* Name with hover effect */}
              <h3 className="text-xl font-semibold text-[#13689b] hover:text-white transition-all duration-300">
                {value.name}
              </h3>

              {/* Overlay for hover effect */}
              <div className="absolute inset-0 bg-[#13689b] opacity-0 group-hover:opacity-20 transition-opacity duration-300 rounded-xl"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Values;
